import { t } from 'i18next';

import { Icon } from '../UI';

export const NoSearchResults = () => (
  <div className="m-auto">
    <div className="flex w-20 h-20 mx-auto rounded-full bg-grey-5">
      <Icon svgName="search" className="m-auto h-8 w-8" color="grey-30" />
    </div>
    <p className="text-center font-medium text-md my-2">
      {t('placeholders.search.0')}
    </p>
    <ul className="text-center text-grey-50">
      <p>{t('placeholders.search.1')}</p>
      <p>{t('placeholders.search.2')}</p>
    </ul>
  </div>
);
